import { e as f, k as h, h as t } from "./color-scale-utils-ePX_zGmy.mjs";
function i(a, e) {
  return a && f(a, e, h);
}
function k(a, e) {
  return function(r, n) {
    if (r == null)
      return r;
    if (!t(r))
      return a(r, n);
    for (var u = r.length, s = e ? u : -1, b = Object(r); (e ? s-- : ++s < u) && n(b[s], s, b) !== !1; )
      ;
    return r;
  };
}
var E = k(i);
const v = E;
export {
  v as b
};
//# sourceMappingURL=_baseEach-FYvKsL62.mjs.map
